import { View } from '@amzn/stencil-react-components/layout';
import React from 'react';

export const IconFolder = ({ size }) => {
  return (
    <View height={size} width={size}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="#23756b" viewBox="0 0 512 512">
        <path
          stroke-width={'4px'}
          d="M447.1 96h-172.1L226.7 50.75C214.7 38.74 198.5 32 181.5 32H63.1c-35.35 0-64 28.66-64 64v320c0 35.34 28.65 64 64 64h384c35.35 0 64-28.66 64-64V160C511.1 124.7 483.3 96 447.1 96zM463.1 416c0 8.824-7.178 16-16 16h-384c-8.822 0-16-7.176-16-16V96c0-8.824 7.178-16 16-16h117.5c4.273 0 8.293 1.664 11.31 4.688L255.1 144h192c8.822 0 16 7.176 16 16V416z"
        />
      </svg>
    </View>
  );
};
